module.exports = __webpack_public_path__ + "img/programme-4.3b4a2a4a.png";